import { FC, useCallback } from 'react';

import { useCustomerStore } from 'page/ReleasePage/TaskPage/hooks';
import { CustomerForForms } from 'types/customer';
import { CustomerListView } from 'components/organisms/CustomerListView/CustomerListView';

export const CustomerList: FC = () => {
  const {
    loading,
    id,
    name,
    detail,
    total,
    isSelectedAll,
    isIndeterminate,
    filteredCustomers,
    selectedCustomersLength,
    toggleCustomer,
    toggleAllCustomers,
    changeId,
    changeName,
    changeDetail,
  } = useCustomerStore();

  /**
   * 顧客一覧のヘッダのチェックボックスををクリックしたときの処理
   */
  const handleParentCheckboxClick = useCallback(() => {
    toggleAllCustomers();
  }, [toggleAllCustomers]);

  /**
   * 顧客一覧のチェックボックスを変更したときの処理
   * @param customer 変更された顧客
   */
  const handleCheckboxChange = useCallback(
    (customer: CustomerForForms) => {
      toggleCustomer(customer.id, !customer.isSelected);
    },
    [toggleCustomer],
  );

  /**
   * 顧客一覧で行をクリックしたときの処理
   * @param customer クリックされた顧客
   */
  const handleCustomerClick = useCallback(
    (customer: CustomerForForms) => {
      toggleCustomer(customer.id, !customer.isSelected);
    },
    [toggleCustomer],
  );

  /**
   * 検索フィールドの ID を変更したときの処理
   * @param _id ユーザが入力した ID
   */
  const handleIdChange = useCallback(
    (_id: string) => {
      changeId(_id);
    },
    [changeId],
  );

  /**
   * 検索フィールドの顧客名を変更したときの処理
   * @param _name ユーザが入力した顧客名
   */
  const handleNameChange = useCallback(
    (_name: string) => {
      changeName(_name);
    },
    [changeName],
  );

  /**
   * 検索フィールドの顧客を変更したときの処理
   * @param _detail ユーザが入力した顧客詳細
   */
  const handleDetailChange = useCallback(
    (_detail: string) => {
      changeDetail(_detail);
    },
    [changeDetail],
  );

  return (
    <CustomerListView
      loading={loading}
      id={id}
      name={name}
      detail={detail}
      total={total}
      selectedCustomersLength={selectedCustomersLength}
      filteredCustomers={filteredCustomers}
      isSelectedAll={isSelectedAll}
      isIndeterminate={isIndeterminate}
      handleParentCheckboxClick={handleParentCheckboxClick}
      handleCheckboxChange={handleCheckboxChange}
      handleIdChange={handleIdChange}
      handleNameChange={handleNameChange}
      handleDetailChange={handleDetailChange}
      handleCustomerClick={handleCustomerClick}
    />
  );
};
